import * as React from 'react';

const ChevronDown = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M5.62022 10.1069C5.91385 9.83102 6.38993 9.83102 6.68357 10.1069L12 15.1019L17.3164 10.1069C17.6101 9.83102 18.0861 9.83102 18.3798 10.1069C18.6734 10.3828 18.6734 10.8301 18.3798 11.106L12 17.1L5.62022 11.106C5.32659 10.8301 5.32659 10.3828 5.62022 10.1069Z"
      fill="#71717A"
    />
  </svg>
);
export default ChevronDown;
